import React, {  useEffect, useState } from "react";
import Adminhomemenu from "../Menus/Adminhomemenu";

export default function Createrendomtest() {
  useEffect(() => {
    handleLogin();
  }, []);
  const user = JSON.parse(localStorage.getItem("user"));
  const [tradeId, setTradeid] = useState(user?.TRADE_ID);
  const tradeName = user?.TRADE_NAME;
  const uid = user?.UID;
  const [tradedata, settradeData] = useState({ data: [] });
  const [testName, settestName] = useState("");
  const [batchNumber, setbatchNumber] = useState("");
  const [testDate, settestDate] = useState("");
  const LANGUAGE_ID = user?.LANGUAGE_ID;
  const [testTime, setTestTime] = useState("");
  const [numofQue, setnumofQue] = useState("20");
  const [topics, setTopics] = useState([]);
  const [selectedTopics, setSelectedTopics] = useState([]);
  const [showTopics, setShowTopics] = useState(false);
  const handleLogin = async () => {
    try {          
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_SUBJECT}`;
      //REACT_APP_REGESTER_USER
      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          TRADE_ID: tradeId,
          TRADE_NAME: tradeName,
        }),
      });

      if (!res.ok) throw new Error(`Server error: ${res.status}`);

      const data = await res.json();
      settradeData(data);      
    } catch (err) {}
  };
  useEffect(() => {
    if (tradedata.data.length > 0) {
      setTradeid(tradedata.data[0].TRADE_ID);
      fetchTopics(tradedata.data[0].TRADE_ID);
    }
  }, [tradedata]);
  const submitFinalTest = async () => {
    if (selectedTopics.length === 0) {
      alert("Please select at least one topic");
      return;
    }
    const finalDateTime = `${testDate} 15:00:00`;
    const finalTime = `${testDate} ${testTime}:00`;
    // alert("Selected subject id=" + tradedata.data[0].TRADE_ID);
    const topicIdsString = selectedTopics.join(",");
    // alert("test Name " + testName);    
    // alert("Exam date " + finalDateTime);
    // alert("Exam time " + finalTime);
    // alert(numofQue);
    // alert("language id" + LANGUAGE_ID);
    //alert("topic ids" + topicIdsString);

    const path1 = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_CREATE_RANDOM_TEST}`;   
    const res = await fetch(path1, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        BATCH_NUM: batchNumber,
        NUMBER_OF_Q: numofQue,
        TEST_DATE: finalDateTime,
        TEST_TIME: finalTime,
        TOPIC_IDS: topicIdsString,
        UID: uid,
        LANGUAGE_ID: LANGUAGE_ID,
        TEST_NAME: testName,
      }),
    });
    const data = await res.json();    
    if (data.res === "success") {
      alert("Test created successfully" +data.data.TestCode );
    } else {
      alert("Something went wrong");
    }
  };

  const showdata = () => {
    
    // const finalDateTime = `${testDate} 15:00:00`;
    // const finalTime = `${testDate} ${testTime}:00`;
    // alert("Selected subject id=" + tradedata.data[0].TRADE_ID);
    // alert("test Name " + testName);
    // alert("Batch number " + batchNumber);
    // alert("Exam date " + finalDateTime);
    // alert("Exam time " + finalTime);
    // alert(numofQue);
    // alert("language id" + LANGUAGE_ID);
    setShowTopics(true);
    // const handleRegister = async () => {
    //   try {
    //     const path1 = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_CREATE_RANDOM_TEST}`;
    //     const res1 = await fetch(path1, {
    //       method: "POST",
    //       headers: { "Content-Type": "application/json" },
    //       body: JSON.stringify({
    //         BATCH_NUM: batchNumber,
    //         NUMBER_OF_Q: numofQue,
    //         TEST_DATE: testDate,
    //         TEST_TIME: testTime,
    //         TOPIC_IDS: "2,5,6,7",
    //         UID: uid,
    //         LANGUAGE_ID: LANGUAGE_ID,
    //         TEST_NAME: testName,
    //       }),
    //     });

    //     if (!res1.ok) throw new Error(`Server error: ${res1.status}`);

    //     const data = await res1.json();
    //     if (data.res === "success") {
    //       setToastType("success");
    //       setToastMsg("User registered successfully");
    //       setShowToast(true);
    //       setIsRegister(false);
    //     } else {
    //       setToastType("danger");
    //       setToastMsg("User already exists");
    //       setShowToast(true);
    //     }
    //   } catch (err) {
    //     setToastType("danger");
    //     setToastMsg("Server error, try again later");
    //     setShowToast(true);
    //   }
    // };
  };
  const fetchTopics = async (trade_id) => {
    try {
      const path1 = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_TOPIC}`;
      const res = await fetch(path1, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          TRADE_ID: trade_id,
        }),
      });

      const json = await res.json();
      setTopics(json.data || []);      
      setSelectedTopics([]); // subject change thay to old selection clear
    } catch (err) {
      console.error("Topic fetch error", err);
    }
  };

  const handleCheckboxChange = (topicId) => {
    setSelectedTopics(
      (prev) =>
        prev.includes(topicId)
          ? prev.filter((id) => id !== topicId) // uncheck
          : [...prev, topicId], // check
    );
  };
  const setData = (e) => {
    setTradeid(e);    
    fetchTopics(e);
  };
  return (
    <>
      <Adminhomemenu title="EasyITI" testhistory="testhistory"/>

      <div
        className="container"
        style={{
          paddingTop: "90px",
          height: "auto",
        }}
      >
        <div className="card shadow p-3 mb-5 bg-body rounded">
          <div className="card-header fw-bold fs-5">Create Random Test</div>
          <div
            className="card-body"
            style={{ minHeight: "100vh", overflowY: "auto" }}
          >
            <div className="row mb-3 align-items-center">
              <div className="col-md-4 fw-semibold">Select Subject</div>

              <div className="col-md-8">
                <select
                  className="form-control mb-2"
                  onChange={(e) => setData(e.target.value)}
                >
                  {tradedata.data.map((item) => (
                    <option key={item.TRADE_ID} value={item.TRADE_ID}>
                      {item.TRADE_NAME}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <div className="col-md-4 fw-semibold">Enter Test Name</div>
              <div className="col-md-8">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Test Name"
                  onChange={(e) => settestName(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <div className="col-md-4 fw-semibold">Enter Batch Number</div>
              <div className="col-md-8">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Batch Number"
                  onChange={(e) => setbatchNumber(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <div className="col-md-4 fw-semibold">
                Select No. of Questions
              </div>
              <div className="col-md-8">
                <select
                  className="form-select"
                  onChange={(e) => setnumofQue(e.target.value)}
                >
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                  <option value="70">70</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <div className="col-md-4 fw-semibold">Select Test Date</div>
              <div className="col-md-8">
                <input
                  type="date"
                  className="form-control"
                  value={testDate}
                  onChange={(e) => settestDate(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3 align-items-center">
              <div className="col-md-4 fw-semibold">Select Test Time</div>
              <div className="col-md-8">
                <input
                  type="time"
                  className="form-control"
                  value={testTime}
                  onChange={(e) => setTestTime(e.target.value)}
                />
              </div>
            </div>
            <div className="text-end mt-4">
              <button className="btn btn-primary px-4" onClick={showdata}>
                Generate Test
              </button>
            </div>
            <div>
              {showTopics && (
                <>
                  <hr />
                  <h6 className="fw-bold mb-3">Select Topics</h6>

                  <div className="row">
                    {topics.map((topic) => (
                      <div className="col-md-6 mb-2" key={topic.TOPIC_UID}>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`topic-${topic.TOPIC_UID}`}
                            value={topic.TOPIC_UID}
                            checked={selectedTopics.includes(topic.TOPIC_UID)}
                            onChange={() =>
                              handleCheckboxChange(topic.TOPIC_UID)
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`topic-${topic.TOPIC_UID}`}
                          >
                            {topic.TOPIC_NAME}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="text-end mt-4">
                    <button
                      className="btn btn-success px-4"
                      onClick={submitFinalTest}
                    >
                      Submit Test
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}